// ProductsPrice.js (Improved Design & Enhanced)
import React from 'react';
import './ProductsPrice.css';

let __elakayInfoSource;
const __setElakayInfoSource = (infoSource) => { if (infoSource) __elakayInfoSource = infoSource; };
const __elakayText = (key, fallback) =>
  __elakayInfoSource?.laguangeElakay?.("frontElakayHardcodedText", __elakayInfoSource.languageAPI)?.["productsPrice"]?.[key] || fallback;

const ProductsPrice = ({
  page = 0,
  products,
  showAddToCart,
  showAddToCartButton = true,
  tax = 0.1,
  tca = 0,
  shipping = 0.3,
  filtername
}) => {
  // Calcul du nouveau prix avec réduction
  const newPrice = (Number(products?.price) || 0) * (100 - (Number(products?.salePrice) || 0)) / 100;

  // Prix original (affiché seulement si réduction)
  const olderPrice = products?.salePrice > 0 ? products?.price : null;

  // Pourcentage de réduction
  const discountPercent = products?.salePrice > 0 ? products?.salePrice : 0;

  // Calcul du prix total pour le panier (page 1)
  const calculateCartTotal = () => {
    return products.reduce((currentValue, nextValue) => {
      const basePrice = (Number(nextValue?.price) || 0) * (100 - (Number(nextValue?.salePrice) || 0)) / 100;
      const taxAmount = basePrice * tax;
      const shippingAmount = basePrice * shipping;
      const tcaAmount = basePrice * tca;
      return currentValue + (Number(nextValue?.count) || 0) * (basePrice + taxAmount + shippingAmount + tcaAmount);
    }, 0);
  };

  // Formatage du prix selon la devise (même convention que incomePrice.js / wallet.js / CheckoutCart.js)
  const formatPrice = (price) => (Number(price) || 0).toLocaleString('en-US', {
    style: 'currency',
    currency: 'USD',
  });

  // Affichage pour la page produit (page 0)
  const ProductPriceDisplay = () => (
    <div className="product-price-container">
      <div className="price-main-row">
        <div className="price-info">
          <span className="current-price">{formatPrice(newPrice)}</span>

          {olderPrice && (
            <>
              <span className="original-price">{formatPrice(olderPrice)}</span>
              <span className="discount-badge">-{discountPercent}%</span>
            </>
          )}
        </div>

        {showAddToCartButton && (
          <div className="add-to-cart-wrapper">
            {showAddToCart(filtername)}
          </div>
        )}
      </div>
    </div>
  );

  // Affichage pour le panier (page 1)
  const CartTotalDisplay = () => {
    const total = calculateCartTotal();

    return (
      <div className="cart-total-container">
        <div className="total-row">
          <span className="total-label">{__elakayText("t001", "Total:")}</span>
          <span className="total-amount">{formatPrice(total)}</span>
        </div>
      </div>
    );
  };

  return (
    <>
      {page === 0 && <ProductPriceDisplay />}
      {page === 1 && <CartTotalDisplay />}
    </>
  );
};

export default ProductsPrice;
